import { createApiHandler } from './handler';

const coupons = {
  apiClient: null,
  path: '/admin/coupons',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async getRedemptions(id, params = {}) {
    try {
      const queryParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value);
        }
      });
      const url = `${this.path}/${id}/redemptions${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await this.apiClient.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default coupons;
